import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AssistantFeedback } from '@vi-iot/client/apis/assistant/assistant.api-model';
import { isEqual } from 'lodash-es';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AssistantFeedbackState, AssistantStore } from 'src/app/@store/assistant';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-assistant-feedback-export-list',
  templateUrl: './assistant-feedback-export-list.component.html',
  styleUrls: ['./assistant-feedback-export-list.component.scss'],
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantFeedbackExportListComponent implements OnInit, OnDestroy {
  getFilteredAssistantDocuments: AssistantFeedback[];
  disabled = false;
  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(public assistantStore: AssistantStore, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.assistantStore.assistantFeedbackState$
      .pipe(distinctUntilChanged(isEqual), takeUntil(this.ngUnsubscribe$))
      .subscribe((assistantFeedbackState: AssistantFeedbackState) => {
        this.disabled =
          !assistantFeedbackState.feedbackData.loaded ||
          assistantFeedbackState.feedbackData.loading ||
          assistantFeedbackState.feedbackData.value.length === 0;

        if (assistantFeedbackState.feedbackData.value.length > 0) {
          this.getFilteredAssistantDocuments = assistantFeedbackState.feedbackData.value;
        }

        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  generateCsv(): void {
    const csvData = this.convertToCSV();
    const blob = new Blob([csvData], { type: 'text/csv;charset=UTF-8' });
    const link = document.createElement('a');
    link.setAttribute('href', window.URL.createObjectURL(blob));
    link.setAttribute('download', 'feedbacks.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(): string {
    if (this.getFilteredAssistantDocuments.length > 0) {
      const headers = Object.keys(this.getFilteredAssistantDocuments[0]).join(',');

      const rows = this.getFilteredAssistantDocuments.map((doc) => {
        return Object.keys(this.getFilteredAssistantDocuments[0])
          .map((key) => {
            let value = doc[key];
            if (Array.isArray(value)) {
              return value.join('|');
            } else if (typeof value === 'boolean') {
              return value ? 'true' : 'false';
            } else if (value !== null && value !== undefined && value.toString().includes(',')) {
              return `"${value.toString().replace(/"/g, '""')}"`;
            } else {
              return value !== null && value !== undefined ? value : '';
            }
          })
          .join(',');
      });

      return `${headers}\n${rows.join('\n')}`;
    } else {
      return;
    }
  }
}
